module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.step === 0 ? 'preview-container with-thing' : 'preview-container'
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 485 134"
    }
  }, [_c('g', {
    staticClass: "previewer"
  }, [_c('rect', {
    staticStyle: {
      "fill": "rgb(255,255,255)"
    },
    attrs: {
      "width": "485",
      "height": "134",
      "x": "0",
      "y": "0"
    }
  }), _vm._v(" "), _c('rect', {
    class: [1, 3, 4, 5].indexOf(_vm.step) !== -1 ? 'active' : null,
    style: (_vm.custom_color && [1, 3, 4, 5].indexOf(_vm.step) !== -1 ? 'fill:' + _vm.custom_color : ''),
    attrs: {
      "width": "230",
      "height": "20",
      "x": "160",
      "y": "18"
    }
  }), _vm._v(" "), _c('circle', {
    class: _vm.step === 1 ? 'active' : null,
    style: (_vm.custom_color && _vm.step === 1 ? 'fill:' + _vm.custom_color : ''),
    attrs: {
      "cy": "67",
      "cx": "69",
      "r": "52"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "description",
    class: _vm.step === 2 ? 'active' : null,
    style: (_vm.custom_color && _vm.step === 2 ? 'fill:' + _vm.custom_color : '')
  }, [_c('rect', {
    attrs: {
      "width": "267",
      "height": "7",
      "x": "160",
      "y": "48"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "240",
      "height": "7",
      "x": "160",
      "y": "58"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "250",
      "height": "7",
      "x": "160",
      "y": "68"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "width": "44",
      "height": "8",
      "x": "160",
      "y": "111"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "77",
      "height": "8",
      "x": "210",
      "y": "111"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "30",
      "height": "8",
      "x": "293",
      "y": "111"
    }
  })]), _vm._v(" "), _c('rect', {
    class: _vm.step === 3 ? 'active' : null,
    style: (_vm.custom_color && _vm.step > 2 ? 'fill:' + _vm.custom_color : ''),
    attrs: {
      "width": "105",
      "height": "29",
      "x": "373",
      "y": "97"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cb3d967"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Preview.vue
// module id = 70
// module chunks = 0